import register from './register/register.js'
import { createStore } from 'vuex'
import { getDefinitions, hexToRgba } from '@/assets/controllers/DefinitionsController.js'
import { commitIndexedDB, getIndexedDBData } from '@/assets/libs/indexedDBService.js'

// stores
import cart from './cart/cart.js'
import persistCart from './plugins/persistCart'
import infrastructure from './infrastructure/infrastructure.js'
import modalProdSelection from './infrastructure/modalProdSelection.js'
import user from './user/user.js'
import menu from './menu/menu.js'
import persistMenu from './plugins/persistMenu.js'
import event from './menu/event.js'
import cardAdditionMenu from './infrastructure/cardAdditionMenu.js'
import cards from './cards/cards.js'
import payment from './payment/payment.js'
import pix from './payment/pix.js'
import recoverPassword from './user/recoverPassword.js'
import homeMenu from './infrastructure/homeMenu.js'
import profileInfra from './user/profileInfra.js'
import orders from './user/orders.js'
import otpAuth from './user/otpAuth.js'

const APP_DEFINITIONS_DBNAME = 'appdefinitions'

export default createStore({
  state: {
    definitions: {},
    isFullApp: true
  },
  getters: {
    getAppDefinitions: (state) => state.definitions,
    isFullApp: (state) => state.isFullApp
  },
  mutations: {
    setdefinitions (state, definitions) {
      state.definitions = definitions
    },
    setFullApp (state, isFullApp) {
      state.isFullApp = isFullApp
    }
  },
  plugins: [persistCart, persistMenu],
  actions: {
    async loadAppDefinitions ({ commit }) {
      let definitions = null
      try {
        try {
          definitions = await getIndexedDBData(APP_DEFINITIONS_DBNAME)
          commit('setdefinitions', definitions)
          // console.log('loadedFromIndexed')
        } catch (err) {
          console.log(err)
        } finally {
          try {
            definitions = await getDefinitions()
            await commitIndexedDB(APP_DEFINITIONS_DBNAME, definitions)
            commit('setdefinitions', definitions)
            // console.log('loadedFromWeb')
          } catch (error) {
            console.log(error)
          }
        }
      } catch (error) {
        console.log(error)
      }
      // definitions && document.documentElement.style.setProperty('--primaryColor', definitions.primaryColor)

      if (definitions) {
        const primary = definitions.primaryColor || '#03004F'
        const primaryTransparent = hexToRgba(primary, 0.05)

        const style = document.documentElement.style
        style.setProperty('--primaryColor', primary)
        style.setProperty('--primaryColorTransparent', primaryTransparent)
      }
    },
    async setFullApp ({ commit }, isFullApp) {
      commit('setFullApp', isFullApp)
    }
  },
  modules: {
    cart,
    infrastructure,
    modalProdSelection,
    user,
    event,
    menu,
    cardAdditionMenu,
    cards,
    payment,
    pix,
    register,
    recoverPassword,
    homeMenu,
    profileInfra,
    orders,
    otpAuth
  }
})
